var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitepagesAddressesScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2b6d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#6d7580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#6d7580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435068"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.10586,23.36607c-5.05991,0-9.16178,4.10187-9.16178,9.16178,0,3.37805,4.08349,9.07267,6.79803,12.48512,1.20977,1.52073,3.51768,1.52073,4.72745,0,2.71459-3.41245,6.79803-9.10707,6.79803-12.48512,0-5.05991-4.10182-9.16178-9.16172-9.16178ZM37.10586,36.24981c-2.05558,0-3.72196-1.66637-3.72196-3.72196s1.66637-3.72196,3.72196-3.72196,3.72196,1.66637,3.72196,3.72196-1.66637,3.72196-3.72196,3.72196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.62777,51.02022c0-.85474.54527-1.58569,1.63678-2.19187,1.08955-.60421,2.18499-.90485,3.27454-.90485,1.12885,0,1.84899.4087,2.16141,1.22513l5.84858,16.60357,4.38374-14.44216c.31242-1.0139,1.17011-1.52085,2.57404-1.52183,1.40492,0,2.25966.50793,2.57404,1.52183l4.32282,14.49816,13.7849-37.29614c.31242-.81839,1.03256-1.22709,2.16141-1.22709,1.05418,0,3.29124.89306,4.38374,1.51692s1.63678,1.36464,1.63678,2.22232c.01456.36519-.06637.72786-.23481,1.05221l-18.04681,43.20662c-.35074.89699-1.344,1.34597-2.98177,1.34794-1.71439,0-2.75089-.45095-3.09966-1.34499l-4.50065-12.74644-4.44366,12.68945c-.3527.93334-1.42457,1.40197-3.21854,1.40492-1.59551,0-2.56913-.46863-2.91987-1.40492l-9.00228-23.09665c-.1847-.34223-.28571-.72336-.29474-1.11215Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepagesAddressesScraper);
export default __webpack_public_path__ + "static/media/whitepages-addresses-scraper.123e89ff6329af7466cd96ddec5de643.svg";
export { ForwardRef as ReactComponent };